import { Suspense, lazy, useEffect, useState } from "react";

const ExitIntentLeadMagnet = lazy(() =>
  import("@/components/ExitIntentLeadMagnet").then((m) => ({
    default: m.ExitIntentLeadMagnet,
  })),
);

/**
 * Mount the exit-intent modal only after the user is idle / has interacted —
 * keeps it out of the critical chunk and skips the cost entirely for bots
 * and very-short visits.
 */
export function DeferredExitIntent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    let done = false;
    const arm = () => {
      if (done) return;
      done = true;
      setReady(true);
    };
    const timer = window.setTimeout(arm, 5000);
    const opts: AddEventListenerOptions = { once: true, passive: true };
    window.addEventListener("scroll", arm, opts);
    window.addEventListener("pointermove", arm, opts);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("scroll", arm);
      window.removeEventListener("pointermove", arm);
    };
  }, []);

  if (!ready) return null;
  return (
    <Suspense fallback={null}>
      <ExitIntentLeadMagnet />
    </Suspense>
  );
}